import { motion } from "motion/react";
import step1Image from "../assets/step1-branding.webp";
import step2Image from "../assets/step2-route.webp";
import step3Image from "../assets/step3-dayplanner.webp";
import step4Image from "../assets/step4-content.webp";

const steps = [
	{ src: step1Image, alt: "Set Up Your Branding" },
	{ src: step2Image, alt: "Build Your Route" },
	{ src: step3Image, alt: "Plan Your Days" },
	{ src: step4Image, alt: "Edit Content" },
];

export function TripBuilderShowcase() {
	return (
		<section className="py-12 md:py-24" style={{ background: "linear-gradient(to bottom, white 0%, #f5f6fa 15%, #f5f6fa 85%, white 100%)" }}>
			<div className="max-w-6xl mx-auto px-6">
				<motion.div
					initial={{ opacity: 0, y: 20 }}
					whileInView={{ opacity: 1, y: 0 }}
					viewport={{ once: true }}
					transition={{ duration: 0.6 }}
					className="mb-12"
				>
					<p className="text-xs font-semibold tracking-widest uppercase mb-3" style={{ color: "#7C3AED" }}>
						Trip Building
					</p>
					<h2
						className="text-3xl md:text-4xl font-bold"
						style={{ fontFamily: "Poppins, sans-serif", color: "#0F1629", maxWidth: 520 }}
					>
						Beautiful <span style={{ color: "#7C3AED" }}>itineraries</span>,<br />built in minutes
					</h2>

					<p className="mt-4" style={{ color: "rgba(15,22,41,0.5)", fontSize: 15, lineHeight: 1.7, maxWidth: 540 }}>
						No design skills needed. Just follow four simple steps and hand your client something that looks like it took days.
					</p>

					<div className="flex flex-wrap items-center gap-3 mt-6">
						{[
							{ n: "01", label: "Brand your trip" },
							{ n: "02", label: "Plan the route" },
							{ n: "03", label: "Build each day" },
							{ n: "04", label: "Add rich content" },
						].map((step, i, arr) => (
							<div key={step.n} className="flex items-center gap-3">
								<div className="flex items-center gap-2">
									<span
										className="inline-flex items-center justify-center w-6 h-6 rounded-full text-white text-xs font-bold flex-shrink-0"
										style={{ background: "linear-gradient(135deg, #C084FC, #7C3AED)", fontSize: 10 }}
									>
										{step.n}
									</span>
									<span style={{ color: "#0F1629", fontSize: 13, fontWeight: 500 }}>{step.label}</span>
								</div>
								{i < arr.length - 1 && <span style={{ color: "rgba(15,22,41,0.18)", fontSize: 16 }}>→</span>}
							</div>
						))}
					</div>
				</motion.div>
			</div>

			<div className="max-w-[1440px] mx-auto px-6">
				<div className="grid grid-cols-2 md:grid-cols-4 gap-4 md:gap-0 items-start">
					{steps.map((step, i) => (
						<motion.div
							key={step.alt}
							initial={{ opacity: 0, y: 32 }}
							whileInView={{ opacity: 1, y: 0 }}
							viewport={{ once: true }}
							transition={{ duration: 0.55, delay: i * 0.1 }}
						>
							<img src={step.src} alt={step.alt} className="w-full h-auto" loading="lazy" />
						</motion.div>
					))}
				</div>
			</div>
		</section>
	);
}
